import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" })
      .then((registration) => registration.update())
      .catch(() => undefined);
  });

  const currentBundle = Array.from(document.scripts)
    .map((script) => script.src && new URL(script.src, window.location.href).pathname)
    .find((path) => /\/assets\/index-[^/]+\.js$/.test(path));
  let reloading = false;

  const reloadWhenBundleChanged = async () => {
    if (!currentBundle || reloading) return;
    try {
      const response = await fetch(`/?version_check=${Date.now()}`, {
        cache: "no-store",
        credentials: "same-origin",
      });
      if (!response.ok) return;
      const html = await response.text();
      const latestBundle = html.match(/src=["'](\/assets\/index-[^"']+\.js)["']/)?.[1];
      if (latestBundle && latestBundle !== currentBundle) {
        reloading = true;
        window.location.reload();
      }
    } catch {
      // A temporary network failure must not interrupt the current session.
    }
  };

  window.addEventListener("focus", () => void reloadWhenBundleChanged());
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void reloadWhenBundleChanged();
  });
  window.setInterval(() => void reloadWhenBundleChanged(), 60_000);
}
